<template>
  <div class="input-copy-component">
    <div @click="copiarLink()" class="act-inter">
      <img
        :src="require('@/assets/icons/action-link.svg')"
        alt="Link to pay"
      />
      <span>Copy Paynow link</span>
    </div>
    <input
      type="text"
      :readonly="true"
      ref="link"
      :value="`${pathLink}${link}`"
    />
    <template v-if="loadMsg">
      <span class="link">{{msg}}</span>
    </template>
  </div>
</template>
<script>
export default {
  name: 'input-copy',
  data() {
    return {
      loadMsg: false,
      msg: 'Copied',
      pathLink: `${process.env.VUE_APP_URL}/payment/`,
    };
  },
  props: {
    link: String,
  },
  methods: {
    async copiarLink() {
      try {
        const linkInvoice = await this.$refs.link;
        linkInvoice.select();
        document.execCommand('copy');
        this.loadMsg = true;
        this.closeMsg();
      } catch (e) {
        console.error(e);
      }
    },
    closeMsg() {
      setTimeout(() => {
        this.loadMsg = false;
      }, 3000);
    },
  },
  computed: {
    cLink() {
      if (this.link) {
        return this.link;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.input-copy-component {
  position: relative;
  // display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 22px;
  height: 22px;
  .act-inter {
    display: flex;
    span {
      margin-left: 10px;
      color: $header;
    }
  }
  img {
    width: 25px;
    height: 25px;
  }
  input {
    position: absolute;
    z-index: -1;
    outline: none;
    left: 12px;
    top: 0;
    width: 1px;
    height: 1px;
  }
  .link {
    position: absolute;
    margin-left: 200px;
    top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 25px;
    z-index: 9999;
    box-shadow: 0px 0px 7px rgba(48, 48, 48, 0.25);
    border-radius: 5px;
    background-color: $white;
    color: $payed;
  }
}
</style>
